import { Pie } from '@visx/shape';

export interface DonutSlice {
  id: string;
  label: string;
  value: number;
  color: string;
}

/** Share of a whole (e.g. allocation at a date). Negative/zero slices are omitted. */
export function Donut({
  slices,
  size,
  label,
}: {
  slices: readonly DonutSlice[];
  size: number;
  label: string;
}) {
  const positive = slices.filter((s) => s.value > 0);
  const radius = size / 2;
  return (
    <svg width={size} height={size} role="img" aria-label={label}>
      <g transform={`translate(${String(radius)},${String(radius)})`}>
        {positive.length === 0 ? (
          <circle
            r={radius - 6}
            fill="none"
            style={{ stroke: 'var(--chart-grid)' }}
            strokeWidth={10}
          />
        ) : (
          <Pie
            data={positive}
            pieValue={(s) => s.value}
            outerRadius={radius}
            innerRadius={radius * 0.62}
            padAngle={0.012}
            cornerRadius={2}
          >
            {(pie) =>
              pie.arcs.map((arc) => (
                <path key={arc.data.id} d={pie.path(arc) ?? ''} style={{ fill: arc.data.color }} />
              ))
            }
          </Pie>
        )}
      </g>
    </svg>
  );
}
